import { render, staticRenderFns } from "./ActionButtonView.vue?vue&type=template&id=66587b73&scoped=true&"
import script from "./ActionButtonView.vue?vue&type=script&lang=js&"
export * from "./ActionButtonView.vue?vue&type=script&lang=js&"
import style0 from "./ActionButton.scss?vue&type=style&index=0&id=66587b73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66587b73",
  null
  
)

export default component.exports